import { isProduction } from "fe-common/utils/envGetter";

export const CLINIC_BASE_URL = isProduction()
  ? "https://clinic.kahun.com/"
  : "https://clinic-dev.kahun.com/";
export const CLINIC_CHAT_LINK = isProduction()
  ? "https://patient.kahun.com/clinic/"
  : "https://patient-dev.kahun.com/clinic/";
export const STANDALONE_TUTORIAL =
  "https://www.kahun.com/clinics-management-tutorial#content";
export const CLINIC_MANAGE_URL = "/clinic_manage";

export const EXTENSION_URL = "/extension-onbarding";
